import fetch from "auth/FetchInterceptor";

const funcionogramaService = {};

funcionogramaService.getOne = function (id) {
	return fetch({
		url: `/v1/rest/organizational-structure-jobs/${id}`,
		method: "get",
	});
};

funcionogramaService.get = function (id) {
	return fetch({
		url: `/v1/rest/jobs-list/${id}`,
		method: "get",
	});
};

funcionogramaService.post = function (data) {
	return fetch({
		url: `/v1/rest/organizational-structure-jobs`,
		method: "post",
		data: data,
	});
};

funcionogramaService.put = function (data) {
	return fetch({
		url: `/v1/rest/organizational-structure-jobs/${data.id}`,
		method: "put",
		data: data,
	});
};

funcionogramaService.del = function (id) {
	return fetch({
		url: `/v1/rest/organizational-structure-jobs/${id}`,
		method: "delete",
	});
};

funcionogramaService.getAtividades = function (id) {
	return fetch({
		url: `/v1/rest/job-roles/${id}`,
		method: "get",
	});
};

funcionogramaService.postAtividade = function (data) {
	return fetch({
		url: `/v1/rest/job-roles`,
		method: "post",
		data: data,
	});
};

funcionogramaService.putAtividade = function (data) {
	return fetch({
		url: `/v1/rest/job-roles/${data.id}`,
		method: "put",
		data: data,
	});
};

funcionogramaService.delAtividade = function (id) {
	return fetch({
		url: `/v1/rest/job-roles/${id}`,
		method: "delete",
	});
};

export default funcionogramaService;
